var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { Widget, WidgetGroup } from '@easyquery/core';
var LocaleWidget = /** @class */ (function (_super) {
    __extends(LocaleWidget, _super);
    /**
    * The default constructor.
    * @param slot The html element.
    */
    function LocaleWidget(slot) {
        var _this = _super.call(this, slot) || this;
        _this.changeLocale = function () {
            var newLocale = _this.selectEl.value;
            i18n.setCurrentLocale(newLocale);
            _this.context.refreshWidgets(WidgetGroup.All);
        };
        _this.group = WidgetGroup.None;
        return _this;
    }
    LocaleWidget.prototype.init = function (context, options) {
        _super.prototype.init.call(this, context, options);
        this.clear();
        this.render();
    };
    LocaleWidget.prototype.getWidgetType = function () {
        return 'changeLocale';
    };
    LocaleWidget.prototype.render = function () {
        var locales = i18n.getLocales();
        if (locales.length > 1) {
            this.selectEl = document.createElement('select');
            for (var _i = 0, locales_1 = locales; _i < locales_1.length; _i++) {
                var locale = locales_1[_i];
                var optionEl = document.createElement('option');
                optionEl.value = locale.locale;
                optionEl.innerHTML = this.displayLocaleName(locale);
                this.selectEl.appendChild(optionEl);
            }
            this.selectEl.value = i18n.getCurrentLocale();
            this.selectEl.classList.add('eqv-select');
            this.selectEl.addEventListener('change', this.changeLocale);
            this.slot.appendChild(this.selectEl);
        }
    };
    LocaleWidget.prototype.displayLocaleName = function (locale) {
        if (locale.englishName && locale.displayName) {
            return locale.englishName + " - " + locale.displayName;
        }
        else if (locale.englishName) {
            return locale.englishName;
        }
        else if (locale.displayName) {
            return locale.displayName;
        }
        return locale.locale;
    };
    LocaleWidget.prototype.clear = function () {
        this.slot.innerHTML = "";
    };
    LocaleWidget.prototype.destroyCore = function () {
        this.clear();
    };
    return LocaleWidget;
}(Widget));
export { LocaleWidget };
//# sourceMappingURL=locale_widget.js.map